import { AnyAction } from 'redux';
import { WellnessScoreState } from '../schema';
import {
  SET_WELLNESS_SCORE,
  SET_WELLNESS_SCORE_LOADING,
  SET_WELLNESS_SCORE_ERROR
} from '../middleware';

const initialState: WellnessScoreState = {
  data: null,
  loading: false,
  error: null
};

export const wellnessScoreReducer = (
  state = initialState,
  action: AnyAction
): WellnessScoreState => {
  switch (action.type) {
    case SET_WELLNESS_SCORE:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: null
      };
    case SET_WELLNESS_SCORE_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
        error: null
      };
    case SET_WELLNESS_SCORE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};
